import { ThemeProvider } from "@mui/material";
import { ShiftDiscoverySearchMode } from "@src/appV2/OpenShifts/ShiftAction/api/useClaimShift";
import { ShiftModalsDataProvider } from "@src/appV2/redesign/ShiftDiscovery/useShiftModalsDataContext";
import { getTheme } from "@src/appV2/redesign/system/ui-theme";

import { BOOKING_REQUESTS_FULL_PATH } from "../path";
import { BookingRequestsModalRoutes } from "./BookingRequestsModalRoutes";
import { BookingRequestsPage } from "./Page";

export function BookingRequestsRouteContainer() {
  return (
    <ThemeProvider theme={getTheme()}>
      <ShiftModalsDataProvider
        baseNavigationPath={BOOKING_REQUESTS_FULL_PATH}
        searchMode={ShiftDiscoverySearchMode.LIST}
      >
        <BookingRequestsPage />
        <BookingRequestsModalRoutes />
      </ShiftModalsDataProvider>
    </ThemeProvider>
  );
}
